.popoverContent {
    padding: var(--mantine-spacing-sm);
    min-width: 12.5rem;
}

.badge {
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    letter-spacing: 0.03rem;
    text-transform: uppercase;
    opacity: 0.6;
    margin-bottom: var(--mantine-spacing-3xs);
}

.category {
    font-size: var(--mantine-font-size-sm);
    font-weight: 600;
    margin-bottom: var(--mantine-spacing-xxs);
}

.timeRow {
    display: flex;
    align-items: baseline;
    gap: var(--mantine-spacing-3xs);
    font-family: var(--mantine-font-family-monospace);
    margin-bottom: var(--mantine-spacing-xxs);
}

.elapsed {
    font-size: var(--mantine-font-size-md);
    font-weight: 700;
}

.target {
    font-size: var(--mantine-font-size-sm);
    opacity: 0.5;
}

.onTrack {
    color: var(--mantine-color-teal-4);
}

.approaching {
    color: var(--mantine-color-yellow-4);
}

.exceeded {
    color: var(--mantine-color-red-4);
}

.statusText {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    margin-top: var(--mantine-spacing-xxs);
}

.salesContext {
    font-size: var(--mantine-font-size-xs);
    margin-top: var(--mantine-spacing-3xs);
    opacity: 0.7;
}
